import * as angular from "angular";
import {IController} from "angular";

export class serviceAreasListItemCtrl implements IController {

  serviceAreasListCtrl: any;
  serviceArea: any;
  isSelected: boolean;

  private siteDistanceUnit: any;

  /* @ngInject */
  constructor(private splitService) {}

  $onInit() {
    this.siteDistanceUnit = this.splitService.getSiteDistanceLargeUnit(true);
  }

}
angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasListItem', {
    require: {
      serviceAreasListCtrl: '^serviceAreasList'
    },
    bindings: {
      serviceArea: '<',
      isSelected: '<'
    },
    template: require('./service-areas-list-item.html').default,
    controller: serviceAreasListItemCtrl
  });
